<div class="yf-row center gap-4">
  <ion-icon name="speedometer-outline" color="light" class="medium-icon"></ion-icon>
  <ion-text color="warning" [class]="$textClass()">{{$power() | power}} <span [class]="$umClass()">kW</span></ion-text>
  <!-- <ion-text color="light" class="fs-12"> / {{$currentSession().powerLimit | power}} <span class="fs-8">kW</span></ion-text> -->
</div>